import CompanyProfileEditComponent from "../components/CompanyProfileEdit";
import useCompanyProfileEdit from "../hooks/useCompanyProfileEdit";

const CompanyProfileEdit = (props) => {
  const companyProfileEditProps = useCompanyProfileEdit(props);
  return <CompanyProfileEditComponent {...companyProfileEditProps} />;
};

export default CompanyProfileEdit;
